import axios from 'axios';
import { SERIES_ID_IPL, TEAMS_OBJ } from 'constants/cricket';
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';

const BottomStripIPL = ({setShowLiveAtBottom}) => {


    const scoreData = useSelector((state) => state.SeriesReducer.scoreData);


    const filterBySeries = (allMatches) => {
        return allMatches.filter((match) => match.series_Id == SERIES_ID_IPL);
    };

    const sortByDate = (matches) => {
        return matches.sort(
            (a, b) => new Date(a.matchdate_ist) - new Date(b.matchdate_ist)
        );
    };


    const [liveId, setLiveId] = useState(null)
    const [liveData, setLiveData] = useState(null)

    useEffect(() => {
        // const live = false
        //match is live
        if (
            scoreData?.live &&
            scoreData?.live?.channel?.live?.length > 0 &&
            filterBySeries(scoreData?.live?.channel?.live).length > 0
        ) {
            const data = sortByDate(filterBySeries(scoreData?.live?.channel?.live));
            // setMatchData(data[0]);
            setLiveId(data[0]?.match_Id);
            setShowLiveAtBottom(true)

            setLiveData({
                seriesName: data[0]?.series_name,
                matchId : data[0]?.match_Id,
                matchNumber: data[0]?.matchnumber,
                teamAId: data[0]?.teama_Id,
                teamBId: data[0]?.teamb_Id,
                whoIsBowling: data[0]?.inn_team_1,
                whoIsBatting: data[0]?.inn_team_2,
                bowlingTeamScore: data[0]?.inn_score_1,
                battingTeamScore: data[0]?.inn_score_2,
                teamALogo: data[0]?.teama_flag,
                teamBLogo: data[0]?.teamb_flag,
                teamAShort : data[0]?.teama_short,
            teamBShort : data[0]?.teamb_short,
                teamAName: data[0]?.teama_hn,
                teamBName: data[0]?.teamb_hn,
                matchStatus: data[0]?.matchresult,
                matchResult: data[0]?.matchstatus,
                pageSlugSt: data[0]?.page_slug_st,
                showStar:
                    data[0]?.inn_team_1 == data[0]?.teama_Id
                        ? data[0]?.teama_Id
                        : data[0]?.teamb_Id,
            });
        }
        else {
            setLiveId(null)
            setShowLiveAtBottom(false)
            setLiveData(null)
        }
    }, [scoreData])

    useEffect(() => {
        if (liveId) {
          const poolingLiveMatches = async () => {
            const response = await axios.get(
              `${process.env.NEXT_PUBLIC_BASE_URL
              }/api/getRecentMatch?id=${liveId}&nocache=${new Date().getTime()}`
            );
            let fetchedData = response?.data ?? null;
    
            if (fetchedData?.data?.response?.scorecard?.match_Id?.length > 0) {
              // // setLiveData(fetchedData?.data?.response?.scorecard);
              // //update the array of carousel
              // setCarouselMatches(carouselMatches?.map(it => {
              //   if(it.channel.scorecard.match_Id == fetchedData?.data?.response?.scorecard?.match_Id){
              //     return item.channel.scorecard
              //   }
              //   else{
              //     return it
              //   }
              // }))
              const data = fetchedData?.data?.response?.scorecard;
              //set the match data of the live match
            //   setMatchData(data);
              setLiveData({
                seriesName: data?.seriesname,
                matchId : data?.match_Id,
                matchNumber: data?.matchnumber,
                teamAId: data?.teama_Id,
                teamBId: data?.teamb_Id,
                whoIsBowling: data?.current_bowling_team_id,
                whoIsBatting: data?.current_batting_team,
                bowlingTeamScore: data?.bowlingTeamStats,
                battingTeamScore: data?.battingTeamStats,
                teamALogo: data?.teama_logo,
                teamBLogo: data?.teamb_logo,
                teamAName: data?.teama_hn,
                teamBName: data?.teamb_hn,
                teamAShort : data?.teama_short,
            teamBShort : data?.teamb_short,
                matchStatus: data?.matchresult_hn,
                matchResult: data?.matchStatus_hn,
                pageSlugSt: data?.page_slug_st,
                showStar:
                  data?.current_bowling_team_id == data?.teama_Id
                    ? data?.teamb_Id
                    : data?.teama_Id,
              });
            } else {
              // alert("Please refresh the page.");
              // Refresh the page after user clicks OK
              // window.location.reload();
            }
          };
    
          let interval = setInterval(() => {
            poolingLiveMatches();
          }, 3000);
          return () => clearInterval(interval);
        }
      }, [liveId]);


      function splitString(input) {
 
        let index = input.indexOf('(');
        if (index === -1) return [input, '']; // If '(' is not found
  
        let before = input.substring(0, index).trim();
        let after = input.substring(index).trim();
  
        return [before, after];
      }



      const onCardClick = async (matchId) => {
    
        //fetch the status of the match
        const response = await axios.get(
          `${process.env.NEXT_PUBLIC_BASE_URL
          }/api/getRecentMatch?id=${matchId}&nocache=${new Date().getTime()}`
        );
        let fetchedData = response?.data ?? null;
        if (fetchedData?.data?.response?.scorecard?.match_Id?.length > 0) {
          const data = fetchedData?.data?.response?.scorecard;
          let page = null
          if (data.is_live == 1) {
            page = 'live'
          }
          else if (data.upcoming == 1) {
            page = 'info'
          }
          else {
            page = 'summary'
          }
          window.location.href = `/sports/ipl/${data?.page_slug_st}/stats/${page}`
    
        }
    
      }
    
    return (liveId && liveData) ?  (
        <div
        id="IPL_STRIP"
            className='row w-100 my-3' style={{
                height: "73px",
                backgroundImage: "url(/assets/images/ipl_microsite/ipl_banner.jpg)",
                backgroundSize: "cover",
                backgroundPosition: "center",
            }}
        >
            <div className='row align-items-center p-0 m-0'>
                <div className='col-8'>
                    <div className='d-flex justify-content-between align-items-center w-100'>
                        <div className='d-flex align-items-center gap-2'>
                            <div style={{ width: "30px", height: "30px" }}>
                                <img alt="Team_Logo" src={TEAMS_OBJ[liveData?.teamAShort]? TEAMS_OBJ[liveData?.teamAShort]   :liveData?.teamALogo} style={{ width: "100%", height: "100%" }} className='w-100 h-100' />
                            </div>
                            <div>
                                <p className='m-0 p-0 text-white' style={{ fontSize: "14px", fontWeight: 700 }}>
                                {liveData?.teamAId == liveData?.whoIsBowling
                ? splitString(liveData?.bowlingTeamScore)[0]
                : splitString(liveData?.battingTeamScore)[0]}{" "}
              {liveData?.showStar == liveData?.teamAId && " *"}
                                </p>
                                <p className='m-0 p-0 text-white' style={{ fontSize: "10px", fontWeight: 400 }}>
                                {liveData?.teamAId == liveData?.whoIsBowling
                ? splitString(liveData?.bowlingTeamScore)[1]
                : splitString(liveData?.battingTeamScore)[1]}{" "}
              
                                </p>
                                
                            </div>
                        </div>
                        <p className='m-0 p-0' style={{ fontWeight: 400, fontSize: "13px", color: "rgba(255, 255, 255, 0.5)" }}>v/s</p>
                        <div className='d-flex align-items-center gap-2'>
                            
                            <div>
                                <p className='m-0 p-0 text-white' style={{ fontSize: "14px", fontWeight: 700 }}>
                                {liveData?.teamBId == liveData?.whoIsBowling
                ? splitString( liveData?.bowlingTeamScore)[0]
                : splitString(liveData?.battingTeamScore)[0]}{" "}
              {liveData?.showStar == liveData?.teamBId && " *"}
                                </p>
                                <p className='m-0 p-0 text-white' style={{ fontSize: "10px", fontWeight: 400 }}>
                                {liveData?.teamBId == liveData?.whoIsBowling
                ? splitString( liveData?.bowlingTeamScore)[1]
                : splitString(liveData?.battingTeamScore)[1]}{" "}
                                </p>
                               
                            </div>
                            <div style={{ width: "30px", height: "30px" }}>
                                <img alt="Team_Logo" src={TEAMS_OBJ[liveData?.teamBShort]? TEAMS_OBJ[liveData?.teamBShort]   :liveData?.teamBLogo} style={{ width: "100%", height: "100%" }} className='w-100 h-100' />
                            </div>
                        </div>
                    </div>
                </div>
                <div className='col-4 h-100  d-flex align-items-center justify-content-center'
                    style={{
                        clipPath: "polygon(20% 0%, 100% 0%, 100% 100%, 0% 100%)",
                        backgroundColor: "rgba(235, 14, 140, 1)"
                    }}
                >
                    <div onClick={() => {
                        onCardClick(liveData?.matchId)
                    }} className="d-flex gap-2 align-items-center" style={{cursor : "pointer"}}>
                        <p className='m-0 p-0 text-white' style={{ fontSize: "10px", fontWeight: 400  }}>Match Center</p>

                        <svg width="8" height="11" viewBox="0 0 8 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2.03516 1.25781L6.21563 5.31966L2.03516 9.80906" stroke="white" stroke-width="2.13781" stroke-linecap="round" />
                        </svg>

                    </div>
                </div>
            </div>
        </div>
    ) : null
}

export default BottomStripIPL